const peiAnalysisService = {
  EducacionEspecial: 126,
  TerapiaDeHabla: 127,
  TerapiaOcupacional: 128,
  TerapiaPsicológica: 129,
  TerapiaFísica: 130,
  TerapiaEducativa: 131,
  Otros: 134,
  TerapiaInstruccional: 717,
  EducacionFisicaAdaptada: 721,
  Educativo: 126,
  TerapiaOromotora: 672,
  EducacionFisicaAdaptadaCombinada: 1749,
  ServicioCiegos: 1768,
  ServicioSordos: 1769,
  TerapiaDisfagia: 662,
  ConsejeriaRehabilitacion: 1823,
  LenguajeSenas: 1854
};

export default peiAnalysisService;
